module.exports = __webpack_public_path__ + "img/floorplan-2.7c23c8f9.png";